import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./styles/HeroHeader.css";
import "./styles/App.css";
import MetaTags from "./components/MetaTags";
import MainContent from "./components/MainContenst";
import Footer from "./components/Footer";
import { initHeroHeaderScripts } from "./utils/heroHeaderScripts";
import Header from "./components/Header";

function App() {
  useEffect(() => {
    // Initialize hero header scripts
    const cleanup = initHeroHeaderScripts();

    // Preloader cleanup dengan timeout fallback
    const hidePreloader = () => {
      const preloader = document.querySelector("#preloader");
      if (preloader) {
        preloader.classList.add("hidden");
      }
    };

    // Hide preloader saat load event
    window.addEventListener("load", hidePreloader);

    // Fallback: hide preloader after 1,5 seconds (lebih cepat)
    const preloaderTimeout = setTimeout(() => {
      console.log("Preloader auto-hide (timeout)");
      hidePreloader();
    }, 1500);

    // Array dari script yang ingin dimuat
    const scripts = [
      "/assets/vendor/bootstrap/js/bootstrap.bundle.min.js",
      "/assets/vendor/php-email-form/validate.js",
      "/assets/vendor/aos/aos.js",
      "/assets/vendor/glightbox/js/glightbox.min.js",
      "/assets/vendor/purecounter/purecounter_vanilla.js",
      "/assets/vendor/swiper/swiper-bundle.min.js",
      "/assets/js/main2.js",
    ];

    // Untuk menyimpan node script yang dibuat
    const scriptElements = [];

    // Load scripts sequentially to guarantee dependencies load before
    // dependent scripts execute (e.g. ensure GLightbox is available before
    // main2.js runs).
    const loadScriptSequential = (index) => {
      if (index >= scripts.length) return Promise.resolve();
      const src = scripts[index];
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = false;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          console.log(`✓ Script loaded: ${src}`);
          scriptElements.push(script);
          resolve(loadScriptSequential(index + 1));
        };
        script.onerror = (err) => {
          console.error(`✗ Script failed to load: ${src}`, err || "error");
          // Still attempt to continue loading remaining scripts, but reject
          // the promise so the overall failure is visible.
          scriptElements.push(script);
          resolve(loadScriptSequential(index + 1));
        };
        document.body.appendChild(script);
      });
    };

    // Start sequential loading
    loadScriptSequential(0).catch((e) => {
      console.error("Error during sequential script loading:", e);
    });

    // Cleanup: hapus script saat komponen unmount
    return () => {
      clearTimeout(preloaderTimeout);
      window.removeEventListener("load", hidePreloader);
      scriptElements.forEach((script) => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      });
      if (cleanup) cleanup();
    };
  }, []);

  useEffect(() => {
    // Initialize AOS (Animate on Scroll) setelah semua script load
    const aosTimer = setTimeout(() => {
      if (window.AOS) {
        window.AOS.init({
          duration: 1000,
          easing: "ease-in-out",
          once: true,
          offset: 100,
        });
        console.log("✓ AOS initialized");
      } else {
        console.warn("✗ AOS not available");
      }
    }, 1500); // Wait untuk AOS script load

    return () => clearTimeout(aosTimer);
  }, []);

  return (
    <div className="App">
      <MetaTags />
      <Header />
      <MainContent />
      <Footer />

      {/* Scroll Top */}
      <button
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
        aria-label="Scroll to top"
        type="button"
      >
        <i className="bi bi-arrow-up-short"></i>
      </button>

      {/* Preloader */}
      <div id="preloader"></div>
    </div>
  );
}

export default App;
